let apply = {
    path: '/m/mkaa',
    name: 'PeHe',
    component: () => import(`@/views/mapply/applyActivity.vue`),
    meta: {'title': '活动工具', 'keepAlive': true},
    redirect: '/m/mkaa/index',
    children: [
      {
        path: '/m/mkaa/index',
        name: 'ApplyIndex',
        component: () => import(`@/views/mapply/activity/applyIndex.vue`),
        meta: {'title': '首页', 'keepAlive': true}
      },
      {
        path: '/m/mkaa/list',
        name: 'ApplyList',
        component: () => import(`@/views/mapply/activity/applyList.vue`),
        meta: {'title': '活动列表', 'keepAlive': true}
      },
      {
        path: '/m/mkaa/activityDetail',
        name: 'ActivityDetail',
        component: () => import(`@/views/mapply/activity/activityDetail.vue`),
        meta: {'title': '活动详情', 'keepAlive': true}
      },
      {
        path: '/m/mkaa/chooseTickets',
        name: 'ChooseTickets',
        component: () => import(`@/views/mapply/activity/chooseTickets.vue`),
        meta: {'title': '选择票种', 'keepAlive': true}
      },
      {
        path: '/m/mkaa/participants',
        name: 'Participants',
        component: () => import(`@/views/mapply/activity/participants.vue`),
        meta: {'title': '报名人员', 'keepAlive': true}
      },
      {
        path: '/m/mkaa/confirmOrder',
        name: 'AaConfirmOrder',
        component: () => import(`@/views/mapply/ticketPage/aaConfirmOrder.vue`),
        meta: {'title': '提交订单', 'keepAlive': true}
      },
      {
        path: '/m/mkaa/enrollment',
        name: 'AaEnrollment',
        component: () => import(`@/views/mapply/ticketPage/aaEnrollment.vue`),
        meta: {'title': '选择报名', 'keepAlive': true}
      },
      {
        path: '/m/mkaa/paymentResult',
        name: 'AaPaymentResult',
        component: () => import(`@/views/mapply/ticketPage/aaPaymentResult.vue`),
        meta: {'title': '支付结果', 'keepAlive': true}
      },
      {
        path: '/m/mkaa/sginUpAdd',
        name: 'AaSginUpAdd',
        component: () => import(`@/views/mapply/ticketPage/aaSginUpAdd.vue`),
        meta: {'title': '新增报名', 'keepAlive': true}
      },
      {
        path: '/m/mkaa/myTic',
        name: 'myTicket',
        component: () => import(`@/views/mapply/ticketPage/myTicket.vue`),
        meta: {'title': '我的票券', 'keepAlive': false}
      },
      {
        path: '/m/mkaa/ticDet',
        name: 'ticketDetails',
        component: () => import(`@/views/mapply/ticketPage/ticketDetails.vue`),
        meta: {'title': '票券详情', 'keepAlive': false}
      },
      {
        path: '/m/mkaa/gTicDet',
        name: 'getTicketDetails',
        component: () => import(`@/views/mapply/ticketPage/getTicketDetails.vue`),
        meta: {'title': '领取的票券详情', 'keepAlive': false}
      },
      {
        path: '/m/mkaa/oTicDet',
        name: 'oneTicketDetails',
        component: () => import(`@/views/mapply/ticketPage/oneTicketDetails.vue`),
        meta: {'title': '单个票券详情', 'keepAlive': false}
      },
      {
        path: '/m/mkaa/ticShare',
        name: 'tickteShare',
        component: () => import(`@/views/mapply/ticketPage/ticketShare.vue`),
        meta: {'title': '票券分享', 'keepAlive': false}
      },
      {
        path: '/m/mkaa/getTic',
        name: 'getTicket',
        component: () => import(`@/views/mapply/ticketPage/getTicket.vue`),
        meta: {'title': '领取票券', 'keepAlive': false}
      },
      {
        path: '/m/mkaa/signUp',
        name: 'signUp',
        component: () => import(`@/views/mapply/signUp/signUp.vue`),
        meta: {'title': '签到', 'keepAlive': false}
      },
      {
        path: '/m/mkaa/myIndex',
        name: 'MyIndex',
        component: () => import(`@/views/mapply/mine/index.vue`),
        meta: {'title': '个人中心', 'keepAlive': false}
      },
      {
        path: '/m/mkaa/hostView',
        name: 'AaHostView',
        component: () => import(`@/views/mapply/ticketPage/aaHostView.vue`),
        meta: {'title': '主办方详情', 'keepAlive': true}
      },
      {
        path: '/m/mkaa/myGetTicDet',
        name: 'MyGetTicDet',
        component: () => import(`@/views/mapply/ticketPage/myGetTicketDetails.vue`),
        meta: {'title': '票券详情', 'keepAlive': false}
      },
    ]
  }
export default [apply]